import type { Asset, Network } from "rujira.js";

type SearchableAssetOverviewOption = {
  asset: Asset;
  networks?: readonly Network[];
  featured?: boolean;
};

export const filterAssetOverviewOptions = <
  T extends SearchableAssetOverviewOption,
>(
  options: T[],
  search: string,
  showAll: boolean,
  hasToggle: boolean,
  networkLabel: (network: Network) => string
): T[] => {
  const query = search.trim().toLowerCase();

  return options.filter(({ asset, featured, networks }) => {
    if (!query) return showAll || !hasToggle || featured;

    const searchableNetworks = new Set([asset.chain, ...(networks || [])]);
    const searchableValues = [
      asset.metadata.symbol,
      ...[...searchableNetworks].flatMap((network) => [
        network,
        networkLabel(network),
      ]),
    ];

    return searchableValues.some((value) =>
      value.toLowerCase().includes(query)
    );
  });
};
